import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import {
  Label,
  EmailInput,
  EmailSuffix,
  InputWrapper,
  Information,
  ErrorMessage,
} from '../StyledComponents';
import TextInput from '../../../../shared/FormStyles/TextInput.jsx';

const EmailWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const EmailInputWrapper = styled(InputWrapper)`
  margin: 0 0 16px;
  border: 1px solid;
  border-radius: 8px;
  border-color: ${({ error }) =>
    error ? themeGet('colors.error.default') : themeGet('colors.black.20')};
`;

const EMAIL_SUFFIX = '@ourairbo.com';

const Email = ({
  demo,
  handleChange,
  setFieldValue,
  handleBlur,
  inputError,
}) => {
  const { t } = useTranslation('boardSetup');

  return (
    <EmailWrapper>
      <Label>
        {t('formLabel.email')}
        <Information
          className="fa-regular fa-circle-info fa-sm"
          data-tip={t('email.emailAddressDataTip')}
          data-offset="{ 'right': 170 }"
        />
      </Label>
      <EmailInputWrapper error={!!inputError('email')}>
        <EmailInput
          id="demo_email"
          type="text"
          name="email"
          onChange={e =>
            setFieldValue('email', e.target.value.replace(/\s+/g, ''))
          }
          value={demo.email}
        />
        <EmailSuffix>{EMAIL_SUFFIX}</EmailSuffix>
        {inputError('email') && (
          <ErrorMessage>{inputError('email')}</ErrorMessage>
        )}
      </EmailInputWrapper>
      <TextInput
        label={t('formLabel.customReplyEmailName')}
        dataTip={t('email.emailSenderDataTip')}
        dataOffset="{ 'right': 130 }"
        id="demo_from_email"
        name="customReplyEmailName"
        onChange={handleChange}
        value={demo.customReplyEmailName}
        error={inputError('customReplyEmailName')}
        onBlur={handleBlur}
      />
    </EmailWrapper>
  );
};

export default Email;
